import {
  Box,
  Button,
  Flex,
  GridItem,
  Icon,
  Image,
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  useDisclosure,
  useToast,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { FiUpload } from 'react-icons/fi'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../services/api'
import { FaSearchPlus } from 'react-icons/fa'
import { useParams } from 'react-router-dom'

async function updateImage(data) {
  const response = await api.post('/site/v2/fluxo-layout/upload-imagem-aprovacao', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export const ImagemItem = ({ image, idTabela }) => {
  const params = useParams()

  const { numeroPedido } = params

  const queryClient = useQueryClient()
  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateImage,

    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(['validacao-caricatura-pro', { numero_nota: numeroPedido }], (oldData) => {
        return oldData.map((item) => {
          return {
            ...item,
            images: item.images.map((image) => {
              if (image.id_tabela === data.id_tabela) {
                return { ...image, img: data.url }
              }

              console.log('image', image)
              return image
            }),
          }
        })
      })

      toast({
        title: 'Sucesso',
        description: 'Imagem atualizada com sucesso',
        status: 'success',
      })
    },
  })

  async function handleUpload(file) {
    const formData = new FormData()

    formData.append('arquivo', file)
    formData.append('id_imagem', image.id_tabela)
    formData.append('id_tabela', idTabela)

    await mutateAsync(formData)
  }

  console.log(image)

  const isOriginal = image.tipo === 'Foto Original'

  return (
    <GridItem>
      <Flex flexDir="column" alignItems="center" gap={4} position="relative">
        <ModalExpandedImage image={image} />
        <Image src={image.img} w="182px" h="229px" p={3} boxShadow="md" border="1px solid gray.100" alt={image.tipo} objectFit="cover" />

        <Flex flexDir={'column'} gap={1} alignItems={'center'}>
          <input id={`file-${image.id_tabela}`} type="file" hidden onChange={(e) => handleUpload(e.target.files[0])} />
          <Button
            cursor="pointer"
            isLoading={isLoading}
            as="label"
            htmlFor={`file-${image.id_tabela}`}
            maxW="fit-content"
            size="sm"
            leftIcon={<FiUpload />}
            colorScheme="blue"
            variant="ghost"
          >
            Subir nova Arte
          </Button>
          {isOriginal && (
            <Button as="a" size="sm" href={image.img} download={`file-${image.id_tabela}`} target="_blank" rel="noopener noreferrer">
              Download arte original
            </Button>
          )}
        </Flex>
      </Flex>
    </GridItem>
  )
}

const ModalExpandedImage = ({ image }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="absolute"
        top="0px"
        right="20px"
        h="40px"
        w="40px"
        borderRadius="50%"
        bg="white"
        boxShadow="md"
      >
        <Icon fontSize="25" as={FaSearchPlus} cursor="pointer" color="#378BBF" onClick={onOpen} />
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{image.tipo}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Image src={image.img} w="100%" h="100%" objectFit="contain" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
